/*jshint globalstrict: false*/

import Vue from 'vue';
import PlaylistShell from '../components/workplace/playlist-shell';
import axios from 'axios';

Vue.component('playlist-shell', PlaylistShell);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/v1/workplace/playlists/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="playlist-vue"]',
    });
});
